import React from 'react';

import { Badge } from '@ergeon/core-components';

interface PropertyContextMessageProps {
  address?: string | null;
  propertyType?: string | null;
  lotArea?: string | null;
  sqFootage?: string | null;
  yearBuilt?: string | null;
  inHoa?: boolean | null;
}

export const PropertyContextMessage: React.FC<PropertyContextMessageProps> = ({
  address,
  propertyType,
  lotArea,
  sqFootage,
  yearBuilt,
  inHoa,
}) => {
  return (
    <div className="flex flex-col justify-start gap-1 w-full text-left">
      {address && (
        <div className="flex flex-col gap-1">
          <strong>{address}</strong>
        </div>
      )}

      {(propertyType || yearBuilt || lotArea || sqFootage) && (
        <div className="flex flex-col gap-1 paragraph-2">
          {propertyType && <span>Type: {propertyType}</span>}
          {yearBuilt && <span>Year Built: {yearBuilt}</span>}
          {lotArea && <span>Lot Area: {lotArea}</span>}
          {sqFootage && <span>Sq Footage: {sqFootage}</span>}
        </div>
      )}

      {inHoa && (
        <div className="flex gap-2">
          <Badge flavor="warning" value="In HOA" />
        </div>
      )}
    </div>
  );
};
